import "./Modal.scss";
import Button from "core/buttons/button/Button";
import Icon from "core/icon/Icon";
import ReactDom from "react-dom";
import warningCircleIcon from "assets/icons/warning-circle.svg";
import { FormattedMessage, useIntl } from "react-intl";

const ClientDeleteWarningModal = ({ open, onClose, onValidate }) => {
  const intl = useIntl();

  if (!open) return null;
  return ReactDom.createPortal(
    <>
      <div className="overlay-style" />
      <div
        className="validation-modal-style"
        style={{ backgroundColor: "#FBF1D6" }}
      >
        <div className="header">
          <Icon color="gray-200" icon="close" onClick={onClose} />
        </div>
        <div className="body">
          <div>
            <div
              style={{
                backgroundImage: `url(${warningCircleIcon})`,
              }}
              className="validation-icon"
            />
          </div>
          <div className="title">
            {intl
              .formatMessage({
                id: "attention",
                defaultMessage: "Attention!",
              })
              .toUpperCase()}
          </div>
          <div className="description">
            <FormattedMessage
              id="client_delete_warning_message"
              defaultMessage="Le client que vous souhaitez supprimer est lié à des missions actives ou passées."
            />
          </div>
          <div
            className="description"
            style={{ marginTop: 0, marginBottom: "2rem" }}
          >
            <FormattedMessage
              id="client_delete_warning_question"
              defaultMessage="Êtes-vous certain de vouloir continuer ?"
            />
          </div>
          <div className="form-buttons">
            <Button
              color="btn-medium gray-700"
              type="submit"
              onClick={onValidate}
              id="button-form-validation"
            >
              OK
            </Button>
          </div>
          <br /> <br />
        </div>
      </div>
    </>,
    document.getElementById("portal")
  );
};

export default ClientDeleteWarningModal;
